module.exports = __webpack_public_path__ + "img/b12.bfb0025a.png";